import React from 'react';
import PropTypes from 'prop-types';

/**
 * ModalBackground - A wrapper that renders a standard HTML div with Bulma class names
 * 
 * This component accepts the same props as Bloomer ModalBackground for easy migration
 */
const ModalBackground = ({
  className = '',
  children = null,
  style = {},
  tag: Tag = 'div',
  pose = null,
  onPoseComplete = null,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['modal-background'];
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <Tag
      className={getClassNames()}
      style={style}
      pose={pose}
      onPoseComplete={onPoseComplete}
      {...props}
    >
      {children}
    </Tag>
  );
};

// eslint-disable-next-line react/require-default-props
ModalBackground.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  tag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  pose: PropTypes.string,
  onPoseComplete: PropTypes.func,
};



export default ModalBackground;
